import React, { useEffect, useState } from "react"
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  allReporting,
  CountryWiseReportFetch,
} from "redux/slice/reporting/reportingSlice"
import { DataFilter } from "components/Common/filters"
import Loader from "components/Common/loader"

const YEAR_OPTIONS = Array.from({ length: 2050 - 2020 + 1 }, (_, i) => {
  const year = 2020 + i
  return { id: year, name: `${year}` }
})

const formatAmount = value =>
  value || value === 0 ? Number(value).toLocaleString() : "-"

export default function Reporting() {
  const dispatch = useDispatch()
  const { countryWiseData, loading } = useSelector(allReporting)
  const [year, setYear] = useState("")

  useEffect(() => {
    const data = {
      ...(year !== "" && { Year: year }),
    }
    dispatch(CountryWiseReportFetch(data))
  }, [year])

  return (
    <div className="reporting-table-container">
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 dot-after ms-3">
              Country-wise reporting
            </CardTitle>
            <CardBody>
              <div
                className="d-flex justify-content-end flex-row align-items-center"
                style={{ width: "100%" }}
              >
                <div className="me-3">
                  <DataFilter
                    options={YEAR_OPTIONS}
                    value={year}
                    label="Year"
                    onChange={e => setYear(e.target.value)}
                  />
                </div>
                <div>
                </div>
              </div>

              <div className="app-table-body">
                {loading ? (
                  <Loader />
                ) : (
                  <Table
                    responsive
                    className="table mb-0 table-bordered text-center"
                  >
                    <thead>
                      <tr>
                        <th rowSpan="2" scope="col" className="align-middle">
                          Country
                        </th>
                        <th colSpan="2" scope="colgroup">
                          No. of Students
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Amount Committed
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Amount Paid
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Balance Amount
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Approved</th>
                        <th scope="col">Returning</th>
                        <th scope="col">Approved</th>
                        <th scope="col">Returning</th>
                        <th scope="col">Approved</th>
                        <th scope="col">Returning</th>
                        <th scope="col">Approved</th>
                        <th scope="col">Returning</th>
                      </tr>
                    </thead>
                    <tbody>
                      {countryWiseData && countryWiseData.length > 0 ? (
                        countryWiseData.map((item, index) => (
                          <tr key={item?.country || index}>
                            <td className="text-nowrap">{item?.country}</td>
                            <td>{item?.approvedStudentCount ?? "-"}</td>
                            <td>{item?.returningStudentCount ?? "-"}</td>
                            <td>{formatAmount(item?.approvedAmountCommitted)}</td>
                            <td>
                              {formatAmount(item?.returningAmountCommitted)}
                            </td>
                            <td>{formatAmount(item?.approvedAmountPaid)}</td>
                            <td>{formatAmount(item?.returningAmountPaid)}</td>
                            <td>{formatAmount(item?.approvedBalanceAmount)}</td>
                            <td>{formatAmount(item?.returningBalanceAmount)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
